var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowLeftIos(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 9,
    viewBox: "0 0 5 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.72476 7.95844C4.99905 7.68415 4.99929 7.23951 4.7253 6.96492L2.06456 4.29837C2.02561 4.25933 2.02561 4.19614 2.06456 4.1571L4.7253 1.49055C4.9993 1.21596 4.99905 0.771321 4.72476 0.49703V0.49703C4.45026 0.222528 4.00521 0.222528 3.7307 0.49703L0.707107 3.52063C0.316583 3.91115 0.316582 4.54432 0.707106 4.93484L3.7307 7.95844C4.0052 8.23294 4.45026 8.23294 4.72476 7.95844V7.95844Z",
    fill: "#415276"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftIos);
export default __webpack_public_path__ + "static/media/arrow-left-ios.3cfcf830ebaf1e4b9e5565699c67ebfe.svg";
export { ForwardRef as ReactComponent };